import { useT } from "@/i18n/I18nProvider";
import { Globe } from "lucide-react";

export default function LanguageToggle({ className = "" }) {
    const { lang, setLang } = useT();
    const other = lang === "fr" ? "en" : "fr";
    return (
        <button
            data-testid="lang-toggle"
            onClick={() => setLang(other)}
            aria-label={lang === "fr" ? "Switch to English" : "Passer au français"}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium border border-[#E8E2D9] text-[#2C2A29] hover:border-[#3D8C95] hover:text-[#3D8C95] transition-colors ${className}`}
        >
            <Globe size={13} />
            <span>{other.toUpperCase()}</span>
        </button>
    );
}
